// extracted by mini-css-extract-plugin
export default {"link":"_aae03dda","imageWrapper":"_ea3b856e","image":"_7809673d","title":"_4815cefa"};